import * as stateManagement from '#packages/stateManagement';
import * as util from '#packages/util';

import type {
  DragLimits,
  FloatingModeBarOwnProps,
  FloatingModeBarStateProps,
} from './floatingModeBar';
import constants from '#packages/constants';
import type {
  MapDispatchToProps,
  MapStateToProps,
  ThunkAction,
} from 'types/redux';
import type { EditorAPI } from '#packages/editorAPI';

type FloatingModeBarDispatchProps =
  | ReturnType<typeof getDraggableSlotsActions>
  | {};

const { getDraggableSlotsActions } = stateManagement.draggableSlots.actions;

const { getStageLayout } = stateManagement.domMeasurements.selectors;

const {
  connect,
  STORES: { EDITOR_API },
} = util.hoc;

const getDragLimits = (state: stateManagement.EditorState): DragLimits => {
  const { top, bottom, right, left, x } = getStageLayout(state);
  const xLimits = [left];
  const yLimits = [top];

  if (right > 0) {
    xLimits.push(right);
  }

  if (bottom > 0) {
    yLimits.push(bottom);
  }

  if (util.fixedStage.isFixedStageEnabled()) {
    xLimits[0] = x;
    yLimits[0] -= constants.UI.FIXED_STAGE_MARGIN_TOP;
  }

  return {
    x: xLimits,
    y: yLimits,
  };
};

const mapStateToProps: MapStateToProps<
  FloatingModeBarStateProps,
  FloatingModeBarOwnProps
> = ({ state }) => {
  return {
    dragLimits: getDragLimits(state),
  };
};

const getEditorAPI: ThunkAction<EditorAPI> = (
  dispatch,
  getState,
  { editorAPI },
) => editorAPI;

const mapDispatchToProps: MapDispatchToProps<
  FloatingModeBarDispatchProps,
  FloatingModeBarOwnProps
> = (dispatch, ownProps) => {
  const editorAPI = dispatch(getEditorAPI);
  if (!ownProps.draggableExtentionSlot) {
    return {};
  }
  return getDraggableSlotsActions(editorAPI, ownProps.draggableExtentionSlot);
};

export default connect(EDITOR_API, mapStateToProps, mapDispatchToProps);
